import { render, staticRenderFns } from "./SalesCard.vue?vue&type=template&id=27131bf4&scoped=true"
import script from "./SalesCard.vue?vue&type=script&lang=ts"
export * from "./SalesCard.vue?vue&type=script&lang=ts"
import style0 from "./SalesCard.vue?vue&type=style&index=0&id=27131bf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27131bf4",
  null
  
)

export default component.exports